import React from 'react';


import IntroB from './Reponsywne/LewyObiektPelny';
import ObAnimated from './Zanimowane/Animated';

const AboutMeLewaStrona = ({ inView, czyZanimowane, link, button, text, tytul}) => {

    return (
        <div>
            {czyZanimowane &&
                <ObAnimated referencja={inView} czyZanimowane={czyZanimowane}>
                    <IntroB tytul={tytul} fontSize={75} refer={inView} button={button} czyZanimowane={czyZanimowane} link={link}>
                        <p className={'text-[34px] absolute'}>{text}</p>
                    </IntroB>
                </ObAnimated>}
            {(czyZanimowane == false) &&
                <ObAnimated referencja={inView} czyZanimowane={czyZanimowane}>
                    <IntroB tytul={tytul} fontSize={75} refer={inView} button={button} czyZanimowane={czyZanimowane} link={link}>
                        <p className={'text-[34px] absolute'}>{text}</p>
                    </IntroB>
                </ObAnimated>}
        </div>
    );
}

export default AboutMeLewaStrona;
